<template>
  <v-container fill-height>
      <transition mode="out-in" name="slide" type="animation">
        <template v-if="downloadWasFinished">
          <v-layout align-center justify-center>
          <v-flex lg10 offset-md-1 xs12>
            <v-layout :wrap="!$vuetify.breakpoint.mdAndUp" align-center justify-center>
              <v-flex xs6>
                <book-cover :cover="cover" @click="bookClicked"/>
              </v-flex>
              <v-flex xs12>
                <book-data :bookData="bookData" :chapters="chapters"></book-data>
              </v-flex>
            </v-layout>
          </v-flex>
          </v-layout>
        </template>
      </transition>
  </v-container>
</template>

<script>
import { db, rdb } from '@/firebase/config';
import BookCover from './BookCover.vue';
import BookData from './BookData.vue';

export default {
  components: { BookCover, BookData },

  mounted() {
    this.$bind('chapters', db.collection('chapters'));
  },
  data: () => ({
    chapters: [],
    cover: null,
    bookData: null,
  }),

  firebase: {
    cover: rdb.ref('bookCover'),
    bookData: rdb.ref('bookData'),
  },

  computed: {
    downloadWasFinished() {
      return this.cover && this.bookData;
    },
  },

  methods: {
    bookClicked() {
      window.open(this.bookData.url);
    },
  },
};
</script>
